<template>
	<div class="rtc-private-acceptor">
		<head-image :id="friend.id" :name="friend.nickName" :url="friend.headImage" :size="100"
			:isShowUserInfo="false"></head-image>
		<div class="acceptor-text">
			{{ tip }}
		</div>
		<div class="btn-group">
			<div class="icon iconfont icon-phone-accept accept" :class="{ 'is-disabled': clicked }" @click="onAccept()"
				title="接受"></div>
			<div class="icon iconfont icon-phone-reject reject" :class="{ 'is-disabled': clicked }" @click="onReject()"
				title="拒绝"></div>
		</div>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

// 来电接听弹窗。视频通话已下线, 只剩语音通话一种模式。
export default {
	name: "rtcPrivateAcceptor",
	components: {
		HeadImage
	},
	data() {
		return {
			// 防连点: 接听/拒绝点一次就锁住, 接听流程是异步的(麦克风权限
			// 检测+接口调用), 连点会重复触发。麦克风被拒时父组件会提示并
			// 保持响铃, 这里解锁让用户授权后能再点。
			clicked: false
		}
	},
	props: {
		friend: {
			type: Object
		}
	},
	methods: {
		onAccept() {
			if (this.clicked) {
				return;
			}
			this.clicked = true;
			this.$emit('accept');
			// 接听可能因麦克风权限被拦(弹窗不关), 稍后解锁允许重试
			setTimeout(() => {
				this.clicked = false;
			}, 3000);
		},
		onReject() {
			if (this.clicked) {
				return;
			}
			this.clicked = true;
			this.$emit('reject');
		}
	},
	computed: {
		tip() {
			return `${this.friend.nickName} 请求和您进行语音通话...`
		}
	}
}
</script>

<style scoped lang="scss">
.rtc-private-acceptor {
	position: absolute;
	display: flex;
	flex-direction: column;
	align-items: center;
	right: 5px;
	bottom: 5px;
	width: 250px;
	height: 250px;
	padding: 20px;
	background-color: #fff;
	box-shadow: var(--im-box-shadow-dark);
	border-radius: 4px;

	.acceptor-text {
		padding: 10px;
		text-align: center;
		font-size: 16px;
	}

	.btn-group {
		display: flex;
		justify-content: space-around;
		margin-top: 20px;
		width: 100%;

		.icon {
			font-size: 60px;
			cursor: pointer;
			border-radius: 50%;

			&.is-disabled {
				opacity: 0.5;
				pointer-events: none;
			}

			&.accept {
				color: green;
				animation: anim 2s ease-in infinite, vibration 2s ease-in infinite;

				@keyframes anim {
					0% {
						box-shadow: 0 1px 0 4px #ffffff;
					}

					10% {
						box-shadow: 0 1px 0 8px rgba(255, 165, 0, 1);
					}

					25% {
						box-shadow: 0 1px 0 12px rgba(255, 210, 128, 1), 0 1px 0 16px rgba(255, 201, 102, 1);
					}

					50% {
						box-shadow: 0 2px 5px 10px rgba(255, 184, 51, 1), 0 2px 5px 23px rgba(248, 248, 255, 1);
					}
				}

				@keyframes vibration {
					0% {
						transform: rotate(0deg);
					}

					25% {
						transform: rotate(20deg);
					}

					50% {
						transform: rotate(0deg);
					}

					75% {
						transform: rotate(-15deg);
					}

					100% {
						transform: rotate(0deg);
					}
				}

			}

			&.reject {
				color: red;
			}
		}
	}
}
</style>
